// 已登录用户修改/设置密码（H9）
// 路径：/#/change-password （从右上角 UserChip 菜单或"忘记密码"流程跳过来）

import { useState, type FormEvent } from "react";
import { Navigate, useNavigate } from "react-router-dom";

import { AuthApiError, setPassword } from "../lib/auth-api";
import { useAuth } from "../lib/use-auth";

export function ChangePasswordPage() {
  const { status, session } = useAuth();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (status === "loading") {
    return (
      <div className="auth-loading">
        <p className="muted">校验登录态…</p>
      </div>
    );
  }
  if (status === "anonymous" || !session) {
    return <Navigate to="/" replace />;
  }

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (pw !== pw2) {
      setError("两次输入不一致");
      return;
    }
    if (!session) return;
    setBusy(true);
    setError(null);
    try {
      await setPassword(session, pw);
      setDone(true);
    } catch (err) {
      setError(
        err instanceof AuthApiError
          ? err.serverMessage
          : err instanceof Error
            ? err.message
            : "未知错误",
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="page page--login">
      <h1>修改密码</h1>
      <p className="muted">
        新密码至少 8 字符，必须同时包含字母与数字。
      </p>

      {done ? (
        <div className="login-hint" style={{ marginTop: 20 }}>
          <p>✓ 密码已更新。下次登录可用邮箱+新密码进入。</p>
          <button
            type="button"
            className="btn btn--primary"
            style={{ marginTop: 12 }}
            onClick={() => nav("/rooms")}
          >
            返回 Rooms
          </button>
        </div>
      ) : (
        <form className="form" onSubmit={submit}>
          <label className="form__row">
            <span>新密码</span>
            <input
              type="password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              minLength={8}
              autoComplete="new-password"
              required
              autoFocus
              disabled={busy}
            />
          </label>
          <label className="form__row">
            <span>再输一次</span>
            <input
              type="password"
              value={pw2}
              onChange={(e) => setPw2(e.target.value)}
              minLength={8}
              autoComplete="new-password"
              required
              disabled={busy}
            />
          </label>

          <div className="form__actions">
            <button
              className="btn btn--primary"
              type="submit"
              disabled={busy || pw.length < 8 || pw !== pw2}
            >
              {busy ? "保存中…" : "保存"}
            </button>
            <button
              type="button"
              className="btn btn--ghost"
              onClick={() => nav(-1)}
              disabled={busy}
            >
              取消
            </button>
          </div>

          {error && (
            <div className="login-hint login-hint--error">
              <p>{error}</p>
            </div>
          )}
        </form>
      )}
    </section>
  );
}
